import React from 'react'
import { ActivityIndicator, View } from 'react-native'

export const AbsoluteSimpleSpinner: React.FunctionComponent = () => {
    return (
        <View
            style={{
                alignContent: 'center',
                justifyContent: 'center',
                position: 'absolute',
                zIndex: 999,
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                width: '100%',
                height: '100%',
                borderRadius: 15,
            }}
        >
            <ActivityIndicator
                size="large"
                style={{ marginBottom: 20, marginTop: 20 }}
            />
        </View>
    )
}
